<template>
  <div class="center">
    <!-- <h1>我是主页</h1> -->
    <img src="/static/img/home-content.png" style="display: block;width: 100%; height: auto;">
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {},
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
       .center {
         display: flex;
         align-items: center;
         justify-content: center;
         height: 100%;
         background-color: #eff0f4;
         padding-right: 60px;
       }
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/home/pages/HomeIndex.vue